import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';

//components
import withPermissions from '~/hoc/withPermissions';
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter';
import Checkbox from '../../../components/CustomCheckbox/CustomCheckbox';
import GenericSearch from '../../../components/GenericForm/IntegrationFilter';
import BulkProjectAssignModal from './BulkProjectAssignModal.js';

//elements
import Button from '../../../components/CustomButton/CustomButton.jsx';
import CustomMultiSelect from '../../../elements/CustomMultiSelect';
import RequiredStar from '../../../elements/RequiredStar.js'

//assets
import CloseIcon from "~/assets/img/modal-close-icon.svg";
import ActivateUser from '../../../assets/img/ActivateUser.svg'
import LoadingSpinner from '../../../elements/LoadingSpinner';

//utils
import { payrollIntegrationOptions } from '../../../utils/constants';

const page_size = 10;

class UserImport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userToSync: [],
            userAddIds: [],
            loading: false,
            showResponseText: '',
            issueArray: [],
            currentCursor: null,
            nextCursor: null,
            currentFilters: null,
            showProjectAssignModal : false,
            savedUserIds : []
        }
    }

    componentDidMount() {
        const params = {
            page_size,
            cursor: this.state.nextCursor,
            action: 'NEXT'
        }
        this.setState({ loading: true }, () => this.loadData(params));
    }

    async loadData(params) {
        try {
            const { userStore } = this.props;
            const { list, nextCursorToken, hasPreviousPage } = await userStore.getAllEmployeeFromIntegration(params);
            const defaultAll = list.map(item => ({
                ...item,
            }));
            this.setState(prevState => ({
                userToSync: defaultAll,
                currentCursor: hasPreviousPage ? nextCursorToken ? parseInt(nextCursorToken) - page_size : prevState.nextCursor : null,
                nextCursor: nextCursorToken && !isNaN(nextCursorToken) ? parseInt(nextCursorToken) : null,
                loading: false
            }));
        } catch (error) {
            console.error(error);
            this.setState({ loading: false });
        }

    }

    importMemberFromIntegration = async () => {
        const { userStore, t, commonStore } = this.props;
        const { userAddIds } = this.state;
        const str = t(`Do You want to Import selected Members into TimeAndControl`);
        confirmAlert({
            title: this.props.t('Confirm to Import'),
            message: str,
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                        this.setState({ loading: true });
                        const __state = {
                            issueArray: [],
                            loading: true,
                            showResponseText: '',
                            userAddIds: userAddIds
                        }
                        return userStore.saveMemberFromIntegration({ users: userAddIds }).then((res2) => {
                            userStore.resetLastListLoadTime();
                            if (res2.issueArray && res2.issueArray.length) {
                                __state.issueArray = res2.issueArray;
                                __state.loading = false;
                            }
                            else {
                                __state.showResponseText = t("Successfully imported selected Members");
                                __state.loading = false;
                                confirmAlert({
                                    title: t('Assign Projects'),
                                    message: t('Would you like to assign projects to these new members?'),
                                    buttons: [
                                        {
                                            label: t('Yes'),
                                            onClick: () => {
                                                this.setState({ showProjectAssignModal: true, savedUserIds: res2.savedUserIds });
                                            }
                                        },
                                        {
                                            label: t('No'),
                                            onClick: () => {
                                            }
                                        }
                                    ]
                                });
                            }
                            return res2;
                        }).catch(error => {
                            console.error({ error });
                            commonStore.addNotification(t(error.message || 'Something went wrong'), null, 'error');
                            __state.loading = false;
                            __state.userAddIds = [];
                        }).finally(() => {
                            this.setState({ ...__state })
                        });
                    },
                },
                {
                    label: this.props.t('No')
                },
            ],
        })
    }

    handleCheckbox = (ele, e) => {
        if (e) {
            this.setState({ userAddIds: [ele, ...this.state.userAddIds] })
        }
        else {
            const updateIds = this.state.userAddIds.filter(item => item.users.id !== ele.users.id)
            this.setState({ userAddIds: updateIds })
        }
    }

    handlePageChange = (isNext) => {
        const { commonStore, t } = this.props;
        const { currentCursor, nextCursor, userToSync } = this.state;
        if ((!nextCursor && isNext) || (!currentCursor && !isNext))
            return commonStore.addNotification(t("No data to display"), null, 'warning');;
        let prevCursor = currentCursor && userToSync[0]?.users?.cursor;
        const params = {
            page_size,
            cursor: isNext ? nextCursor : prevCursor ? prevCursor : currentCursor - page_size,
            action: isNext ? 'NEXT' : 'PREV',
            filter : this.state.currentFilters
        }
        this.setState({ loading: true }, () => this.loadData(params));
    }

    handleFilterChange = async (filters) => {
        this.setState({ currentFilters: filters }, () => this.loadData({ page_size, filter: filters }));
    }

    render() {
        const { t, handleModalState, modalState , commonStore} = this.props;
        const { loading, showResponseText, userToSync, issueArray, nextCursor, currentCursor, showProjectAssignModal } = this.state
        const product = commonStore.config?.integration_details?.product;
        return (
            <>
            <Modal
                size="lg"
                className="modal fade"
                show={modalState}
                onHide={() => handleModalState('showImportComponent', false, true)}
            >
                <Modal.Header>
                    <Modal.Title>{t('Import Members from')} {product}</Modal.Title>
                    <div className='modal-header__revised__closebtn' onClick={() => handleModalState('showImportComponent', false, true)}>
                        <img
                            src={CloseIcon}
                            className="cursor-pointer"
                            alt='close_button'
                        />
                    </div>
                </Modal.Header>
                <Modal.Body className='mb-2'>
                    {
                        product === payrollIntegrationOptions.XLEDGER && <GenericSearch entity="employees" onChange={this.handleFilterChange}  fromDateTooltip="Filter employees who started working after from date"
                        toDateTooltip="Filter employees who started working before to date"  searchTooltip="Search or filter employees by their description or code. If an employee is not in the list, you can still find them using their code or description by clicking on 'Search' option in dropdown." displayName="Employees"/>
                    }
                    {loading &&
                        <>
                            <LoadingSpinner />
                            <div className='text-center'><strong>{t('Hold On, This Will take a moment!')}</strong></div>
                        </>
                    }
                    {!!issueArray.length && !loading &&
                        <>
                            <div className='d-flex flex-column'>
                                <div>
                                    {t('We found some issues while importing the Members')}
                                </div>
                            </div>
                            <div className='projectMemberForm'>
                                <Table className='w-100 '>
                                    <thead>
                                        <tr className='w-100'>
                                            <th width={'40%'} className='text-start'>{t('Members')}</th>
                                            <th width={'20%'}>{t('Issues')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {issueArray.map((ele, idx) => (
                                            <tr key={idx} className='text-capitalize mt-1'>
                                                <td width={'40%'} className='text-start'><div className=''>{ele?.user}</div></td>
                                                <td width={'60%'} className='timelog_array_details text-danger'>
                                                    {ele.message}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </>
                    }

                    {!!showResponseText && !loading &&
                        <div className='d-flex justify-content-center align-items-center flex-column'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" viewBox="0 0 1024 1024">
                                <path fill="#2550AC" d="M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"></path></svg>
                            <div className='text-center'>{showResponseText}</div>
                        </div>
                    }
                    {!showResponseText && !loading &&
                        <>
                            <div className='d-flex justify-content-space-between align-items-center mb-2 w-100'>
                                <div>
                                    <span className='fw-bold font-size-15'>
                                        {t('Select a Member to import')}
                                    </span>
                                </div>
                                <div>
                                    <Button wd
                                        disabled={!currentCursor}
                                        onClick={() => this.handlePageChange(false)}
                                    >
                                        <i class="fa fa-arrow-left me-1" aria-hidden="true"></i>
                                        {t('Prev')}
                                    </Button>
                                    <Button fill wd
                                        disabled={!nextCursor}
                                        style={{ margin: "0 1em" }}
                                        onClick={() => this.handlePageChange(true)}
                                    >
                                        {t('Next')}
                                        <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                                    </Button>
                                </div>
                            </div>
                            <div className='projectMemberForm'>
                                <Table className='w-100 ' style={{ minHeight: '20vh' }}>
                                    <thead>
                                        <tr className='w-100'>
                                            <th width={'50%'} className='text-start'>{t('Members')}</th>
                                            <th width={'20%'}>{t('Synced')}</th>
                                            <th width={'30%'}>{t('Status')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userToSync.map((ele, idx) => (
                                            <tr key={idx} className='text-capitalize mt-1'>
                                                <td width={'50%'} className='text-start'><div className=''>{ele?.users?.displayName}</div></td>
                                                <td width={'20%'} className='timelog_array_details'>
                                                    {ele.isSynced ?
                                                        <img src={ActivateUser} alt='tick' title='Already Synced' />
                                                        :
                                                        <Checkbox
                                                            isChecked={ele.isSynced || ele?.nowSynced}
                                                            onChange={checked => this.handleCheckbox(ele, checked)}
                                                            disabled={ele.isSynced}
                                                            wrapperClassName={'bulk-shift-chekbox-style'}
                                                        />
                                                    }
                                                </td>
                                                <td width={'30%'}>
                                                    <div>
                                                        {ele.isInactive ?
                                                            <div className='d-flex w-75 m-2 p-1'>
                                                                <div className='text-center'>
                                                                    {`${t('Member')} ${t('Inactive')} ${t('in')} ${t('Time&control')}`}
                                                                </div>
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip id="tooltip-top">
                                                                            {t("Employee is already Synced with Time&control, but is inactive. Please navigate to Inactive tab and activate the employee account")}.
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                                                </OverlayTrigger>
                                                            </div>
                                                            :
                                                            <> - </>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        {!userToSync.length &&
                                            <tr>
                                                <td colSpan={3}>
                                                    {t("No data to display")}
                                                </td>
                                            </tr>}
                                    </tbody>
                                </Table>
                            </div>
                            <div className='d-flex mt-2'>
                                <span className='fw-bold font-size-10'>
                                    <RequiredStar />
                                    <RequiredStar />
                                    {t("If the email matches an existing member in our System, the integration process will continue as planned. Please note that we will not responsible for any differences in member's name or details")}.
                                </span>
                            </div>
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {showResponseText === '' ?
                        <>
                            <Button fill wd
                                onClick={this.importMemberFromIntegration}
                                disabled={!this.state.userAddIds.length || this.state.issueArray.length}
                            >
                                {t('Import Selected Users')}
                            </Button>
                            <Button wd
                                onClick={() => handleModalState('showImportComponent', false, true)}
                            >
                                {t('Cancel')}
                            </Button>
                        </>
                        :
                        <>
                            <Button wd
                                onClick={() => handleModalState('showImportComponent', false, true)}
                            >
                                {t('OK')}
                            </Button>
                        </>
                    }
                </Modal.Footer>
            </Modal>
            { showProjectAssignModal && 
                <BulkProjectAssignModal
                        show={true}
                        onHide={() => this.setState({ showProjectAssignModal: false })}
                        isLoading={this.state.loading}
                        savedUserIds={this.state.savedUserIds}
                />
            }
            </>
        );
    }
}
export default inject('userStore', 'commonStore')(applicationRouter(withPermissions(withLocalization(observer(UserImport)))));
